export const localStorageKeys = {
  userId: 'userId',
  pawprintAdminUser: 'pawprintAdminUser',
  secureUser: 'pp_secure_user',
  impersonationIri: 'impersonationIri',
};

interface RedirectMessagesValue {
  key: keyof RedirectMessages;
  message: string;
}

export interface RedirectMessages {
  pawprintAdminImpersonate: RedirectMessagesValue;
  noAccessPawprintAdmin: RedirectMessagesValue;
}
export const redirectMessages: RedirectMessages = {
  pawprintAdminImpersonate: {
    key: 'pawprintAdminImpersonate',
    message: "You can't view business data unless you are impersonating a business owner",
  },
  noAccessPawprintAdmin: {
    key: 'noAccessPawprintAdmin',
    message: 'You do not have access to view pawprint admin',
  },
};

export const SWITCH_USER_HEADER = 'x-switch-user';

export const screenWidths = {
  mobile: {
    min: '360',
    max: '414',
  },
  tablet: {
    min: '601',
    max: '1280',
  },
  desktop: {
    min: '1024',
    largeMin: '1824',
  },
};
